import e from "./ghl-ui.es855.js";
import { createInjectionKey as o } from "./ghl-ui.es896.js";
const r = Object.assign(Object.assign({}, e.props), {
  onPreviewPrev: Function,
  onPreviewNext: Function,
  showToolbar: {
    type: Boolean,
    default: !0
  },
  showToolbarTooltip: Boolean
}), i = o("n-image");
export {
  i as imageContextKey,
  r as imagePreviewSharedProps
};
